import { useGetLoggedInUser } from '@revelio/auth';
import { useTourStore } from '@revelio/core';
import { type KeyValueResp, MetadataKey } from '@revelio/data-access';

/** Whether a user's metadata records the guided tour as finished or skipped. */
export const hasCompletedTour = (
  metadata: ReadonlyArray<KeyValueResp | null> | null | undefined
): boolean =>
  metadata?.find((item) => item?.key === MetadataKey.TourCompleted)?.value ===
  'true';

/**
 * Whether the logged-in user is past the guided tour. The store flag covers
 * this session: `tour_completed` only reaches the metadata after the save and
 * refetch that follow a skip or finish.
 */
export const useIsTourDone = (): boolean => {
  const isTourComplete = useTourStore((s) => s.isTourComplete);
  const { loggedInUser } = useGetLoggedInUser();
  return isTourComplete || hasCompletedTour(loggedInUser.metadata);
};
